import { looksTechnicalError } from "@/lib/api-error";

export async function apiJson<T>(
  path: string,
  init?: RequestInit,
): Promise<T> {
  const res = await fetch(path.startsWith("/api") ? path : `/api${path}`, {
    credentials: "include",
    ...init,
    headers: {
      ...(init?.body instanceof FormData
        ? {}
        : { "Content-Type": "application/json" }),
      ...init?.headers,
    },
  });
  const data = (await res.json().catch(() => ({}))) as T & { error?: string };
  if (!res.ok) {
    const msg = (data as { error?: string }).error;
    throw new Error(
      msg && !looksTechnicalError(msg)
        ? msg
        : `Request failed (${res.status})`,
    );
  }
  return data;
}

export async function transcribeAudio(
  blob: Blob,
  language?: string,
): Promise<string> {
  const form = new FormData();
  form.append("file", blob, "answer.webm");
  if (language) form.append("language", language);
  const res = await fetch("/api/transcribe", {
    method: "POST",
    credentials: "include",
    body: form,
  });
  const data = (await res.json()) as {
    text?: string;
    error?: string;
  };
  if (!res.ok || !data.text) {
    const msg = data.error;
    throw new Error(
      msg && !looksTechnicalError(msg) ? msg : "Transcription failed",
    );
  }
  return data.text;
}
